import { LineConfigurationState } from "../../../line-configurations.model";
import { Fee } from "../../api-models/order-pd-response.model";
import { BaseFlowData } from "../../order.model";
import { ServiceLevelSelectionData } from "../alternate-shipping-address.model";
import { SigfanData } from "./sigfan.model";
import { WirelessAdditionalOfferData } from "./wireless-additional-offer.model";
import { VIAuthCheckFanProductResponse } from "../../../sigfan.model";

export interface WirelessFlow extends BaseFlowData {
    businessVerification?: BusinessVerificationData;
    wirelessSetup?: WirelessSetupData;
    sigfan?: SigfanData;
    lineConfigurations?: LineConfigurationState;
    numberOfWirelessLinesInProgress?: number;
    latestPdPlusCallHappenedOnLine?: number; // last pd plus happened on existing or new line can be initial load or changed by user
    latestPdplusCallActiveOnLine?: number; // this holds only when there is a change on UI by user
    wirelessOffers?: WirelessAdditionalOfferData;
    wirelessAutoBillPay?: WirelessFlowAutoPayInfo;
    serviceLevelSelection?: ServiceLevelSelectionData;
    mobileBusinessAgreement?: MobileBusinessAgreementData;
}

export interface MobileBusinessAgreementData {
    verificationStatus?: string;
}

export interface WirelessSetupData {
    selectedCustomerCode?: string;
    provider?: string;
    authorizedUserList?: string[];
    cpniConsentGrantedAndSubmitClicked?: boolean;
    accountAuthenticationComplete?: boolean;
    authForm?: WirelessAuthFormData;
    authReveal?: WirelessAuthReveal;
    authDisabledControls?: string[];
    accountNumber?: number;
    ctnList?: string[];
    fdeCode?: string;
    fdeMessage?: string;
    smbValidatedAccount?: VIAuthCheckFanProductResponse;
    smbPinSentAt?: number;
    smbSentDeliveryMethod?: string;
}

export interface WirelessAuthFormData {
    mobileNumber?: string;
    fanNumber?: string;
    fanPin?: string;
    pinDeliveryMethod?: string;
    smbOneTimePin?: string;
    attPhoneNumber?: string;
    attBillingZip?: string;
    last4Ssn?: string;
    oneTimePinOrAccountPasscode?: string;
    ctnNumber?: string;
    oneTimePin?: string;
    accountPasscode?: string;
}

export interface WirelessAuthReveal {
    showSearchButton: boolean;
    showZipAndSsnFields: boolean;
    showVerifyAccountButton: boolean;
    showAuthenticationSection: boolean;
    showRequestPinButton: boolean;
    showPinAndAccountPasscodeFields: boolean;
    showSubmitPinButton: boolean;
}

export interface BusinessVerificationData {
    isBusinessVerified?: boolean;
    source1: string;
    source2: string;
    source1Validated: boolean;
    source2Validated: boolean;
    applicantPurchaseAuthority: boolean;
    secondaryIdentification: boolean;
    unableToCompleteValidation: boolean;
}

export interface WirelessFlowAutoPayInfo {
    code: string;
    cartDisclosure: string;
    disclosure: string;
    description: string;
    fee: Fee | null;
}

export enum WirelessFlowType {
    NEW = 'WRLS-COMP-NEW',
    EXISTING = 'WRLS-COMP-EXG'
}
